import React, { useEffect, useState } from 'react';
import { Loader } from '@gravity-ui/uikit';
import { Redirect } from 'react-router';
import { InstallableAppPage } from './InstallableAppPage';
import { isIframe } from 'client/utils';
import { InstallableApp, Channel } from 'client/model/skill';
import { getInstallableApp } from 'client/api';
import { routes } from 'client/lib/routes';
import { tycoon } from 'client/utils/messages';
import { withAppStoreSnapshot, WithAppStoreSnapshot } from 'client/context/appStoreSnapshotContext';

import styles from './InstallableAppPage.module.scss';

interface InstallableAppPageContainerProps {
    skillId: string;
    channel: Channel;
}

type CombinedProps = InstallableAppPageContainerProps & WithAppStoreSnapshot;

const InstallableAppPageContainerFetchApp = ({ channel, skillId }: InstallableAppPageContainerProps) => {
    const [isFetching, setIsFetching] = useState(true);
    const [fetchedAppAsAdmin, setFetchedAppAsAdmin] = useState<InstallableApp>();

    useEffect(() => {
        const fetchInstallableApp = async () => {
            let fetchedApp;
            if (__appConfig.user.isAdmin) {
                try {
                    fetchedApp = await getInstallableApp(skillId, channel);
                } catch (err) {
                    console.error('@Error in fetch installableApp', err);
                }
            }
            if (!fetchedApp && isIframe()) {
                tycoon.sendChatNotFound(skillId);
            }
            setFetchedAppAsAdmin(fetchedApp);
            setIsFetching(false);
        };
        fetchInstallableApp();
    }, [channel, skillId]);

    if (isFetching) {
        return (
            <div className={styles.installableAppPageContainerLoader}>
                <Loader size="l" />
            </div>
        );
    }

    if (!fetchedAppAsAdmin) {
        // TODO: add 404 page
        return <Redirect to={routes.app.installableApps(channel)} />;
    }

    return <InstallableAppPage installableApp={fetchedAppAsAdmin} />;
};

const InstallableAppPageContainer = (props: CombinedProps) => {
    const { appStoreSnapshot, channel, skillId } = props;
    const { installableApps } = appStoreSnapshot;

    const installableApp = installableApps.find(({ id }) => id === skillId);

    if (!installableApp) {
        return <InstallableAppPageContainerFetchApp channel={channel} skillId={skillId} />;
    }

    return <InstallableAppPage installableApp={installableApp} />;
};

export default withAppStoreSnapshot(InstallableAppPageContainer);
